import { render, staticRenderFns } from "./NoticiaCardComponent.vue?vue&type=template&id=27bcfd42&scoped=true"
import script from "./NoticiaCardComponent.vue?vue&type=script&lang=ts"
export * from "./NoticiaCardComponent.vue?vue&type=script&lang=ts"
import style0 from "./NoticiaCardComponent.vue?vue&type=style&index=0&id=27bcfd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bcfd42",
  null
  
)

export default component.exports